import { HttpClient } from '@angular/common/http';
import {
    AfterViewInit,
    Component,
    EventEmitter,
    Input,
    OnDestroy,
    OnChanges,
    OnInit,
    SimpleChanges,
    Output,
    ViewChild,
} from '@angular/core';
import { DataTableDirective } from 'angular-datatables';
import { Subject } from 'rxjs';

import { environment } from 'src/environments/environment';
import { helper } from 'src/environments/helper';
import { RegistruService } from '../../registru.service';

@Component({
    selector: 'app-toate-tabel-registru',
    templateUrl: './toate-tabel-registru.component.html',
    styleUrls: ['./toate-tabel-registru.component.scss'],
})
export class ToateTabelRegistruComponent
    implements OnInit, OnChanges, OnDestroy, AfterViewInit {
    @ViewChild(DataTableDirective, { static: false })
    dtElement!: DataTableDirective;

    @Input() selectedStartDate!: string;
    @Input() selectedEndDate!: string;
    @Input() isArchived: boolean = false;
    @Input() registru_slug: string = '-1';
    @Input() registru_type: number | null = null;

    @Output() extractedDTparams = new EventEmitter();
    helper = helper;

    dtOptions: any = {};
    dtTrigger: Subject<any> = new Subject<any>();
    dtInstance!: DataTables.Api;
    isLoading = false;

    dtLink =
        environment.interop.basePath +
        environment.interop.urbanism.nomenclatoare.registru.listDT;

    constructor(
        private http: HttpClient,
        private registruService: RegistruService
    ) { }

    ngOnChanges(changes: SimpleChanges): void {
        // Același component e refolosit între "Toate" și sluguri necunoscute
        if (changes['registru_slug'] && !changes['registru_slug'].firstChange) {
            this.rerenderDT();
        }
    }

    ngAfterViewInit(): void {
        this.dtTrigger.next('');
    }

    ngOnDestroy(): void {
        this.dtTrigger.unsubscribe();
    }

    ngOnInit(): void {
        this.renderDT();
    }

    renderDT() {
        this.isLoading = true;

        this.dtOptions = {
            responsive: true,
            serverSide: true,
            searching: false,
            pageLength: 25,
            order: [[0, 'desc']],
            ajax: (dataTablesParameters: any, callback: any) => {
                this.isLoading = true;
                dataTablesParameters.date_from = this.selectedStartDate;
                dataTablesParameters.date_to = this.selectedEndDate;
                dataTablesParameters.archived = this.isArchived ? 1 : 0;
                if (this.registru_slug !== '-1') {
                    dataTablesParameters.slug = this.registru_slug;
                    dataTablesParameters.type = this.registru_type;
                }

                this.extractedDTparams.emit(dataTablesParameters);

                this.http
                    .post<any>(this.dtLink, dataTablesParameters)
                    .subscribe((resp: any) => {
                        this.isLoading = false;
                        callback({
                            recordsTotal: resp.data.recordsTotal,
                            recordsFiltered: resp.data.recordsFiltered,
                            data: resp.data.data,
                        });
                    });
            },
            language: environment.config.romanianLanguageDataTable,
            columnDefs: [
                { width: '50px', targets: 0 },
                { width: '100px', targets: 1 },
            ],

            columns: [
                {
                    title: 'ID',
                    data: 'id',
                    render: (data: any, type: any, row: any) => {
                        return `
              <span>${row.id}</span>
            `;
                    },
                },
                {
                    title: `Număr document`,
                    data: 'document_number',
                    render: (data: any, type: any, row: any) => {
                        if (row.document_number) {
                            return `<span>${row.document_number}</span>`;
                        } else {
                            return '<span>N/A</span>';
                        }
                    },
                },
                {
                    title: `Număr cerere`,
                    data: 'cerere_numar',
                    render: (data: any, type: any, row: any) => {
                        if (row.cerere_numar) {
                            return `<span>${row.cerere_numar}</span>`;
                        } else {
                            return '<span>N/A</span>';
                        }
                    },
                },
                {
                    title: `Număr cadastral`,
                    data: 'nr_cadastral',
                    render: (data: any, type: any, row: any) => {
                        if (row.nr_cadastral) {
                            return `<span>${row.nr_cadastral}</span>`;
                        } else {
                            return '<span>N/A</span>';
                        }
                    },
                },
                {
                    title: `Număr dată cerere`,
                    data: 'cerere_data',
                    render: (data: any, type: any, row: any) => {
                        if (row.cerere_data) {
                            return `<span>${row.cerere_data}</span>`;
                        } else {
                            return '<span>N/A</span>';
                        }
                    },
                },
                {
                    title: 'Denumire',
                    data: 'denumire',
                    sortable: false,
                    render: (data: any, type: any, row: any) => {
                        if (row.denumire) {
                            return `<span>${row.denumire}</span>`;
                        } else {
                            return '<span>N/A</span>';
                        }
                    },
                },
                {
                    title: 'Adresă',
                    data: 'strada_name',
                    sortable: false,
                    render: (data: any, type: any, row: any) => {
                        if (row.strada_name) {
                            return `<span>${row.strada_name}</span>`;
                        } else {
                            return '<span>Adresă indisponibilă</span>';
                        }
                    },
                },
                {
                    title: 'Data eliberării',
                    data: 'created_at',
                    sortable: false,
                    render: (data: any, type: any, row: any) => {
                        if (row.created_at) {
                            return `<span>${row.created_at}</span>`;
                        } else {
                            return '<span>Dată indisponibilă</span>';
                        }
                    },
                },
                {
                    title: 'Valabilitate',
                    data: 'valability',
                    sortable: false,
                    render: (data: any, type: any, row: any) => {
                        if (row.valability) {
                            return `<span>${row.valability}</span>`;
                        } else {
                            return '<span>Dată indisponibilă</span>';
                        }
                    },
                },
            ],
        };
    }

    rerenderDT(paginate = false): void {
        this.isLoading = true;
        this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
            this.isLoading = false;
            dtInstance.draw(paginate);
        });
    }
}
